module.exports = __webpack_public_path__ + "static/media/page-memberQA.81a947ba.jpg";